var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.935a10.001 10.001 0 10-11.539 9.946v-6.923H7.9v-3.023h2.561v-2.67a3.423 3.423 0 013.323-3.353 9.67 9.67 0 012.585.215v2.439h-1.646a1.261 1.261 0 00-1.246 1.307v2.062h2.815l-.446 3.023h-2.37v6.923A10.038 10.038 0 0022 11.935z",
    fill: "currentColor"
  })));
}
export default SvgLogoFacebook;